export const selectWatches = state => state.watch.watches || []
export const selectWatchConnected = state => (state.watch.watches || []).length > 0
export const selectWatchDrawerOpen = state => state.watch.drawerOpen
